import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Comment } from 'semantic-ui-react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { ownAnswerWithComments } from '../../selectors';
import { AnswerCommentForm } from '../components';
import { syncValidations, warn, answerLength } from '../validations';
import { newAnswerFormName } from '../constants';
import { answerInputFocused } from '../../actions';
import Answer from '../../Answers/Detail';
import localization from '../../../../localization';
import links from '../../../../links';

const {
    topic: {
        answerBoxLabel,
    },
} = localization;

const {
    max: maxAnswerLength,
} = answerLength;

const NewAnswerForm = reduxForm({
    form: newAnswerFormName,
    validate: syncValidations(maxAnswerLength),
    warn: warn(maxAnswerLength),
})(AnswerCommentForm);

const OwnAnswer = ({
    onSave,
    answer,
    updating,
    onFocusHandler,
}) => {
    if (answer) {
        return (
            <div className="page-container answer own-answer">
                <Comment.Group><Answer
                    answer={answer}
                />
                </Comment.Group>
                <div className="flex flex-row bg-gray-50 p-4 text-sm font-bold font-body md:items-center">
                    <MagnifyingGlassIcon width={24} height={24} className="mr-3 text-purple-gray-600" />
                    <div className="flex w-full flex-wrap gap-y-3 justify-between">
                        <span className="text-gray-700">Keep learning — Explore related cases by searching our case library.</span>
                        <a href={`${links.consensusMd}?navigation_from=dx-questions`} className="text-teal-400">Search Cases</a>
                    </div>
                </div>
            </div>);
    }
    let content;
    if (answer) {
        content = (
            <Comment.Group><Answer
                answer={answer}
            />
            </Comment.Group>);
    } else {
        content = (<NewAnswerForm
            onSave={onSave}
            onFocus={onFocusHandler}
            fieldLabel={answerBoxLabel}
            rows={4}
            submitButtonProps={{
                loading: updating,
            }}
        />);
    }
    return (
        <div className="page-container answer own-answer">
            {content}
        </div>);
};

OwnAnswer.propTypes = {
    onSave: PropTypes.func.isRequired,
    onFocusHandler: PropTypes.func.isRequired,
    answer: PropTypes.shape({}),
    updating: PropTypes.bool,
};

OwnAnswer.defaultProps = {
    answer: null,
    updating: false,
};

const mapStateToProps = (state, { topicId }) => ({
    answer: ownAnswerWithComments(topicId)(state),
});

const mapDispatchToProps = dispatch => ({
    onFocusHandler: () => dispatch(answerInputFocused()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnAnswer);
